import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TestbatchService } from 'src/app/shared/services/test-batch/testbatch.service';
import { AlertService } from 'src/app/shared';
import { first } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-test-batch',
  templateUrl: './test-batch.component.html',
  styleUrls: ['./test-batch.component.scss']
})
export class TestBatchComponent implements OnInit {

  
  public largeModal: any; 

  batches: any = [];
  currentBatch = {
    code: "",
    name: "",
    _id: ""
  };

  sender = "batch-list";

  



  constructor(
    private modalService: NgbModal,
    private testbatchService: TestbatchService, 
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.testbatchService
      .getAll()
      .pipe(first())
      .subscribe(res => {
        this.batches = res;
      });
  }



  open(content, lang) {
    
    this.currentBatch = Object.assign ({},  lang);

    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(result => { });
  }

 

  deleteBatch(lang) {
    Swal.fire({
      title: "Are you sure?",
      text: "Batch data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        this.testbatchService
          .deleteData(lang._id)
          .pipe(first())
          .subscribe(res => {
            this.getAll();
          });
      }
    });
  }

  onSave() {
    if (!this.currentBatch.code) {
      this.alertService.err(this.sender, "Batch Code cannot be Blank");
      return;
    }
    if (!this.currentBatch.name) {
      this.alertService.err(this.sender, "Batch Name cannot be Blank");
      return;
    }
    //saving ....validate ..
    this.testbatchService
      .save(this.currentBatch)
      .pipe(first())
      .subscribe(res => {
        var data = res;
        if (data['status']== "error") {
         this.alertService.err (this.sender, data['message']);
          return;
        }
        this.alertService.show(this.sender, " Language added successfully");
        this.getAll();
        this.modalService.dismissAll();

      });
  }
 
  

}
